import {
  FaRocket,
  FaChartLine,
  FaGem,
  FaEnvelope,
  FaGlobe,
  FaLock,
  FaFileAlt,
  FaChartBar,
  FaFacebook,
  FaStore,
  FaMagic,
  FaHeadset,
  FaBullseye,
} from "react-icons/fa";

export const packages = [
  {
    title: "Getting Started",
    positioning: "A clean, credible launch for new businesses and simple service sites.",
    icon: <FaRocket className="text-blue-600 text-4xl" />,
    badge: "Best Value",
    features: [
      { icon: <FaFileAlt />, text: "1–3 key pages", detail: "A focused site that covers the essentials" },
      { icon: <FaFileAlt />, text: "Custom responsive design", detail: "Looks right on mobile, tablet, and desktop" },
      { icon: <FaChartBar />, text: "SEO foundations", detail: "Search-ready setup to support visibility" },
      { icon: <FaLock />, text: "Secure SSL", detail: "HTTPS enabled by default" },
      { icon: <FaEnvelope />, text: "Enquiry form", detail: "Simple contact flow with clear next steps" },
      { icon: <FaRocket />, text: "Fast turnaround", detail: "A practical option when you need momentum" },
    ],
    note: "* 1st year hosting included",
    detail: "Scope-based pricing. Quick quote after a short call.",
  },
  {
    title: "Growth Build",
    featured: true,
    ribbon: "Most Popular",
    ribbonColor: "bg-blue-600",
    positioning: "Built for growing businesses that need stronger structure, content, and visibility.",
    icon: <FaChartLine className="text-blue-600 text-4xl" />,
    features: [
      { icon: <FaFileAlt />, text: "Everything in Getting Started +", detail: "More pages, more depth, more polish" },
      { icon: <FaGlobe />, text: "Domain and setup support", detail: "We help you get the foundations right" },
      { icon: <FaFileAlt />, text: "Up to 7 pages", detail: "Services, about, FAQs, galleries, and more" },
      { icon: <FaStore />, text: "Optional starter ecommerce", detail: "Sell a small range or take payments" },
      { icon: <FaChartBar />, text: "Enhanced SEO", detail: "Better structure and on-page optimisation" },
      { icon: <FaFacebook />, text: "Social proof connections", detail: "Social links and trust signals where they matter" },
      { icon: <FaEnvelope />, text: "Professional email option", detail: "Support for you@yourdomain.com" },
      { icon: <FaChartLine />, text: "Analytics and tracking", detail: "Know what is working and what to improve" },
    ],
    note: "* 1st year hosting included",
    detail: "Tailored scope. Designed to support growth over time.",
  },
  {
    title: "Scale and Authority",
    icon: <FaGem className="text-blue-600 text-4xl" />,
    positioning: "For established brands, multi-service businesses, and teams that need a site built to scale.",
    features: [
      { icon: <FaFileAlt />, text: "Everything in Getting Started +", detail: "A higher tier build with more capability" },
      { icon: <FaFileAlt />, text: "Flexible page count", detail: "Structured for multiple services and content" },
      { icon: <FaStore />, text: "Enhanced ecommerce options", detail: "A stronger store experience if needed" },
      {
        icon: <FaChartBar />,
        text: "Systems integration",
        detail: "Connect your CRM, bookings, forms, email marketing or administration tools so information flows without unnecessary double handling.",
      },
      { icon: <FaMagic />, text: "Interaction and motion", detail: "Subtle animations that add polish, not noise" },
      { icon: <FaBullseye />, text: "Conversion-focused structure", detail: "Clear pathways that guide users to action" },
      { icon: <FaHeadset />, text: "Priority support option", detail: "Ongoing improvements and maintenance available" },
    ],
    note: "* 1st year hosting included",
    detail: "Quoted after discovery. Clear scope. Fixed deliverables.",
  },
];
